/**
 * Shared state data
 * -----------------------------------------------------------------------------
 *
 * @namespace store
 */

var store = {
  // Elements via data attributes
  selectors: {
    sitePreloader: '[data-site-preloader]',
    productObj: '[data-product-json]',
    siteOverlay: '[data-site-overlay]',
    siteHeader: '[data-site-header]',
    headerSlider: '[data-header-slider]',
    searchLayer: '[data-search-layer]',
    newsletterPopup: '[data-newsletter-popup]',
    carousel: '[data-flickity]',
    productToolbarMobile: '[data-product-toolbar-mobile]',
    productTabs: '[data-product-tabs]',
    accountTabs: '[data-account-tabs]',
    singleOptionSelector: '[data-single-option-selector]',
    qtyContainer: '[data-qty-container]',
    qtyInput: '[data-qty-input]',
    cartItem: '[data-cart-item]',
    productForm: '[data-product-form]',
    cartForm: '[data-cart-form]',
    loginForm: '[data-login-form]',
    recoverForm: '[data-recover-form]',
    passwordInput: '[data-password-input]',
    imageZoom: '[data-img-zoom]',
    donationProduct: '[data-donation-product-json]',
    collectionTemplate: '[data-template-json]'
  },

  page: [],
  answerLog: [],
  resultLog: [],
  allLog: [],
  // Questions
  questions: {
    answer1: '',
    answer2: '',
    answer3: '',
    answer4: '',
    answer5: '',
    answer6: '',
    answer7: '',
    answer8: '',
    answer9: '',
    answer10: '',
    answer11: ''
  },
  // Global objects
  currentTemplate: null,
  isLoading: false,
  moneyFormat: window.theme.moneyFormat,
  colorSwatchesEnabled: window.theme.colorSwatchesEnabled,
  sizeSwatchesEnabled: window.theme.sizeSwatchesEnabled,
  productExcludeTag: window.theme.productExcludeTag,
  selectedSwatchColor: '',
  selectedSwatchSize: '',
  selectedSwatchFinish: '',
  selectedSwatchTechnology: '',
  selectedSwatchLatchType: '',
  selectedSwatchFunction: '',
  selectedSwatchRosettePair: '',
  templateCheck: false,
  imageCheck: false,
  isLoadingResult: false,
  productSelectorURL: '',
  setTimeOne: true,
  setTimeOneBack: true,
  showProducts: false,
  unavailable: false,
  shopifyId: '',

  // ReCharge Integration
  reChargeDiscountVariantId: null
};

export default store;